import _styled from "@emotion/styled-base";
var _excluded = ["tier", "subtle", "icon", "scrollIntoView", "onClose", "children"];

var _templateObject;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}
/* eslint-disable @typescript-eslint/no-shadow */


import { ClassNames, css } from "@emotion/core";
import shouldForwardProp from "@styled-system/should-forward-prop";
import * as React from "react";
import { AlertTriangle, CheckCircle, Info, X } from "react-feather";
import { compose, fontSize, space, width } from "styled-system";
import Box from "../Box";
import { color, elevation, emRhythm } from "../css";
import { useScrollIntoView } from "../ScrollIntoView";
import AlertCloseButton from "./AlertCloseButton";
import AlertContext from "./AlertContext";
import { jsx as ___EmotionJSX } from "@emotion/core";

function getColor(props) {
  var colors = {
    success: props.theme.colors.success,
    warning: props.theme.colors.warning,
    error: props.theme.colors.error
  };
  return props.tier && colors[props.tier] || props.theme.colors.info;
}

var StyledAlert = /*#__PURE__*/_styled("div", {
  shouldForwardProp: shouldForwardProp,
  target: "e1fcaqbm0"
})(function (props) {
  return /*#__PURE__*/css("label:base;display:flex;align-items:baseline;margin:0;border-radius:", props.theme.radii.md, ";color:", getColor(props), ";background-color:transparent;");
}, function (props) {
  return props.subtle || /*#__PURE__*/css("label:with-background;padding:", emRhythm(0.5), " ", emRhythm(0.8), ";color:white;background-color:", getColor(props), ";");
}, compose(color, elevation, fontSize, space, width));

var defaultIcons = {
  success: CheckCircle,
  warning: AlertTriangle,
  error: AlertTriangle
};

function getIconNode(css, icon, tier) {
  if (icon === false) return null;
  var iconProps = {
    className: css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      label: alert-icon;\n      flex: 0 0 auto;\n      margin-right: ", ";\n      /* vertically center the icon */\n      position: relative;\n      top: 0.2em;\n    "])), emRhythm(0.25)),
    size: "1em"
  };

  if (icon == null) {
    return React.createElement(tier && defaultIcons[tier] || Info, iconProps);
  }

  return React.cloneElement(icon, iconProps);
}

export default function Alert(_ref) {
  var tier = _ref.tier,
      subtle = _ref.subtle,
      icon = _ref.icon,
      scrollIntoView = _ref.scrollIntoView,
      onClose = _ref.onClose,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var scrollIntoViewRef = useScrollIntoView();
  return ___EmotionJSX(ClassNames, null, function (_ref2) {
    var css = _ref2.css;
    return ___EmotionJSX(AlertContext.Provider, {
      value: {
        tier: tier,
        subtle: subtle
      }
    }, ___EmotionJSX(StyledAlert, _extends({
      ref: scrollIntoView ? scrollIntoViewRef : undefined,
      tier: tier,
      subtle: subtle
    }, props, {
      role: "alert"
    }), getIconNode(css, icon, tier), ___EmotionJSX(Box, {
      flex: "1",
      lineHeight: "heading",
      fontFamily: "heading"
    }, children), onClose != null && ___EmotionJSX(AlertCloseButton, {
      type: "button",
      "aria-label": "Close",
      onClick: function onClick(event) {
        event.preventDefault();
        onClose();
      }
    }, ___EmotionJSX(X, {
      size: "1em"
    }))));
  });
}
Alert.defaultProps = {
  subtle: false,
  scrollIntoView: false
};